<template>
  <div class='page'>
    <ul>
      <li><button :disabled='currentPage === 1' class='btn-page-num' @click='prevPage'> &lt; </button></li>
      <li v-if='showPrevEllipsis'><a href='javascript:;' class='page-num' @click='goPage(1)'> 1 </a></li>
      <li v-if='showPrevEllipsis'>...</li>
      <li v-for='item in totalPage' v-if='Math.abs(item-currentPage) < 3' :key='item'>
        <a :class='{"page-active": item==currentPage}' href='javascript:;' class='page-num' @click='goPage(item)'>{{ item }}</a>
      </li>
      <li v-if='showNextEllipsis' class='page-num'>...</li>
      <li v-if='showNextEllipsis'><a href='javascript:;' class='page-num' @click='goPage(totalPage)'>{{ totalPage }}</a></li>
      <li><button :disabled='currentPage === totalPage' class='btn-page-num' @click='nextPage'> &gt; </button></li>
    </ul>
  </div>
</template>
<script>
export default {
  props: ['total'],
  data() {
    return {
      currentPage: 1,
    }
  },

  computed: {
    // 总页数
    totalPage() {
      return this.total ? Math.ceil(this.total / 10) : 1
    },
    // 显示/隐藏省略号
    showPrevEllipsis() {
      return this.currentPage >= 4 ? true : false
    },
    // 显示/隐藏省略号
    showNextEllipsis() {
      return ((this.totalPage >= 5) && (this.totalPage - 3 >= this.currentPage)) ? true : false
    }
  },

  methods: {
    // 翻页
    goPage(val) {
      this.currentPage = val 
      this.$emit('change',val)
    },

    // 上一页
    prevPage() {
      this.currentPage > 1 ? this.currentPage -- : this.currentPage = 1
      this.$emit('change',this.currentPage)
    },

    // 下一页
    nextPage() {
      this.currentPage < this.totalPage ? this.currentPage ++ : this.currentPage = this.totalPage
      this.$emit('change',this.currentPage)
    }
  }

}
</script>
<style lang="less" scoped>
.page {
  font-size: 16px;
  margin: 10px 0;
  ul {
    text-align: right;
    li {
      display: inline-block;
      height: 20px;
      line-height: 20px;
      margin: 0 3px;
      .page-num {
        color: #4d4d4d;
        padding: 0 5px;
      }
      .page-active {
        color: #000;
        font-weight: 600;
        font-size: 18px;
      }
      .btn-page-num {
        display: inline-block;
        border: none;
        font-size: 18px;
        outline: none;
        cursor: pointer;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Page.vue